import {
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAIL,
} from "../actionTypes";
import {
  ORDER_LIST_REQUEST,
  ORDER_LIST_SUCCESS,
  ORDER_LIST_FAIL,
} from "../actionTypes";
import {
  ORDER_UPDATE_REQUEST,
  ORDER_UPDATE_SUCCESS,
  ORDER_UPDATE_FAIL,
} from "../actionTypes";
import {
  QR_ACTIVATION_REQUEST,
  QR_ACTIVATION_SUCCESS,
  QR_ACTIVATION_FAIL,
} from "../actionTypes";
import {
  QR_DEACTIVATION_REQUEST,
  QR_DEACTIVATION_SUCCESS,
  QR_DEACTIVATION_FAIL,
} from "../actionTypes";
import {
  ORDER_STATS_REQUEST,
  ORDER_STATS_SUCCESS,
  ORDER_STATS_FAIL,
} from "../actionTypes";
import {
  ORDER_DOWNLOAD_REQUEST,
  ORDER_DOWNLOAD_SUCCESS,
  ORDER_DOWNLOAD_FAIL,
  UPDATE_ORDER_DOWNLOAD_STATUS_REQUEST,
  UPDATE_ORDER_DOWNLOAD_STATUS_SUCCESS,
  UPDATE_ORDER_DOWNLOAD_STATUS_FAIL,
} from "../actionTypes";
import {
  PAYMENT_LIST_REQUEST,
  PAYMENT_LIST_SUCCESS,
  PAYMENT_LIST_FAIL,
} from "../actionTypes";
import {
  STATE_CITY_REQUEST,
  STATE_CITY_SUCCESS,
  STATE_CITY_FAIL,
} from "../actionTypes";

import {
  QRSTATUS_DATE_REQUEST,
  QRSTATUS_DATE_SUCCESS,
  QRSTATUS_DATE_FAILURE,

} from "../actionTypes";
import{
  GET_DEALER_ACCESS_REQUEST,
  GET_DEALER_ACCESS_SUCCESS,
  GET_DEALER_ACCESS_FAIL,
  UPDATE_DEALER_ACCESS_REQUEST,
  UPDATE_DEALER_ACCESS_SUCCESS,
  UPDATE_DEALER_ACCESS_FAIL,
  CREATE_SLOGAN_REQUEST,
  CREATE_SLOGAN_SUCCESS,
  CREATE_SLOGAN_FAIL,
  GET_SLOGAN_REQUEST,
  GET_SLOGAN_SUCCESS,
  GET_SLOGAN_FAIL,
  SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_SUCCESS,
  SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_FAIL,
  SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_REQUEST
} from "../actionTypes";
import { PAYMENT_REQUEST, PAYMENT_SUCCESS, PAYMENT_FAIL } from "../actionTypes";
import {
  CUSTOMER_REDEMPTION_SUMMARY_REQUEST,
  CUSTOMER_REDEMPTION_SUMMARY_SUCCESS,
  CUSTOMER_REDEMPTION_SUMMARY_FAIL,
} from "../actionTypes";
import { approveOrder } from "./OrderApproveActions";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";

export const createOrder = (orderData, token) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    let response;
    let hasPartialSuccess = false;
    let errorDetails = [];

    // Check if there are Excel files in breakdowns
    if (orderData.breakdowns) {
      const breakdownsWithFiles = orderData.breakdowns.filter(
        (b) => b.excelFile
      );

      if (breakdownsWithFiles.length > 0) {
        // Process each breakdown with an Excel file separately
        const uploadResults = await Promise.allSettled(
          breakdownsWithFiles.map(async (breakdown) => {
            const formData = new FormData();
            formData.append("scheme_name", breakdown.scheme);
            formData.append("excel_file", breakdown.excelFile);

            // ✅ Add customer_type to FormData
            if (
              orderData.customer_type &&
              Array.isArray(orderData.customer_type)
            ) {
              orderData.customer_type.forEach((type) => {
                formData.append("customer_type", type);
              });
            } else if (orderData.customer_type) {
              formData.append("customer_type", orderData.customer_type);
            }

            // ✅ Add other fields
            formData.append("order_amount", orderData.order_amount);
            formData.append("qr_quantity", orderData.qr_quantity);
            if (breakdown.remarks) {
              formData.append("remarks", breakdown.remarks);
            }

            return await axiosInstance.post(
              "/api/upload-excel-create-order/",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            );
          })
        );

        // Process results
        const successfulUploads = uploadResults.filter(
          (r) => r.status === "fulfilled"
        );
        const failedUploads = uploadResults.filter(
          (r) => r.status === "rejected"
        );

        // Collect all responses (including partial successes with status 207)
        successfulUploads.forEach((result) => {
          const data = result.value.data;
          if (data.status === 207 && data.errors && data.errors.length > 0) {
            hasPartialSuccess = true;
            errorDetails.push(...data.errors);
          }
        });

        failedUploads.forEach((result) => {
          errorDetails.push(
            result.reason?.response?.data?.detail || "Upload failed"
          );
        });

        response = successfulUploads[0]?.value || uploadResults[0]?.value;
      } else {
        // Order without files
        const cleanedPayload = {
          ...orderData,
          breakdowns: orderData.breakdowns.map((b) => ({
            amount: b.amount,
            quantity: b.quantity,
            scheme: b.scheme,
            remarks: b.remarks,
          })),
          // ✅ Include customer_type in payload
          customer_type: orderData.customer_type,
        };

        response = await axiosInstance.post(
          "/api/create-order/",
          cleanedPayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
    } else {
      // No breakdowns - simple create
      response = await axiosInstance.post("/api/create-order/", orderData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    dispatch({ type: CREATE_ORDER_SUCCESS, payload: response.data });

    // Handle success message with warnings if needed
    const successMessage =
      response.data.message || "Order created successfully.";

    if (hasPartialSuccess && errorDetails.length > 0) {
      toast.warning(
        `${successMessage}\n\nWarnings:\n${errorDetails.join("\n")}`,
        { autoClose: 8000 }
      );
    } else {
      toast.success(successMessage);
    }

    return {
      success: true,
      hasWarnings: hasPartialSuccess,
      errors: errorDetails,
    };
  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response ? error.response.data : error.message,
    });

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to create order";

    toast.error(errorMessage);

    console.error(
      "Error creating order:",
      error.response?.data || error.message
    );

    return { success: false, error: errorMessage };
  }
};
export const updateOrder = (orderData, token) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_UPDATE_REQUEST });
    const response = await axiosInstance.post("/api/update-order/", orderData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: ORDER_UPDATE_SUCCESS, payload: response.data });
    const successMessage =
      response.data.message ||
      "Order updated successfully. Please check your email for the QR code.";
    toast.success(successMessage);
    return { success: true };
  } catch (error) {
    dispatch({
      type: ORDER_UPDATE_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to update order";
    toast.error(errorMessage);
    return { success: false };
  }
};

export const getOrderList =
  (token, params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: ORDER_LIST_REQUEST });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: params,
      };

      console.log("📤 Fetching orders with config:", config);

      const response = await axiosInstance.get("/api/get-order-with-gift-allotments/", config);

      console.log("✅ Response received:", response.data);

      // ✅ IMPORTANT: Your API returns { status, message, data: [...] }
      if (response.status === 200 && response.data.data) {
        console.log("📦 Dispatching orders:", response.data.data);

        dispatch({
          type: ORDER_LIST_SUCCESS,
          payload: response.data.data, // This is the array of orders
        });

        return response;
      } else {
        throw new Error("Unexpected response format");
      }
    } catch (error) {
      console.error("❌ Error fetching orders:", error);

      const errorMsg =
        error.response?.data?.message ||
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch orders";

      dispatch({
        type: ORDER_LIST_FAIL,
        payload: errorMsg,
      });

      throw error;
    }
  };


export const activateQR = (activationData, token) => async (dispatch) => {
  try {
    dispatch({ type: QR_ACTIVATION_REQUEST });

    const response = await axiosInstance.post(
      "/api/activate-qr/",
      activationData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.success) {
      dispatch({
        type: QR_ACTIVATION_SUCCESS,
        payload: {
          order_id: response.data.order_id,
        },
      });
      // alert(
      //   "QR Code activated successfully. Please check your email for the QR code."
      // );
      const successMessage =
        response.data.message ||
        "QR Code activated successfully. Please check your email for the QR code.";
      toast.success(successMessage);
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error || // <- use .error if available
      error.response?.data?.detail || // fallback
      error.message ||
      "Failed to activate QR code";
    dispatch({
      type: QR_ACTIVATION_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    // alert(
    //   error.response?.data?.detail ||
    //     error.message ||
    //     "Failed to activate QR code"
    // );
    toast.error(errorMessage);
  }
};
export const deactivateQR = (orderId, token) => async (dispatch) => {
  try {
    dispatch({ type: QR_DEACTIVATION_REQUEST });

    const response = await axiosInstance.post(
      "/api/deactivate-qr/",
      {
        order_id: orderId,
        deactivate_codes: true,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.success) {
      dispatch({
        type: QR_DEACTIVATION_SUCCESS,
        payload: {
          order_id: response.data.order_id,
        },
      });
    }
    const successMessage =
      response.data.message ||
      "QR Code deactivated successfully. Please check your email for the QR code.";
    toast.success(successMessage);
  } catch (error) {
    dispatch({
      type: QR_DEACTIVATION_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to update order";
    toast.error(errorMessage);
  }
};

export const getOrderStatistics = (token) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_STATS_REQUEST });

    const response = await axiosInstance.get("/api/order-statistics/", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({ type: ORDER_STATS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: ORDER_STATS_FAIL,
      payload:
        error.response?.data?.detail || error.message || "Something went wrong",
    });
  }
};

// export const downloadOrderZIP =
//   (orderId, token, format, customFormData = null) =>
//   async (dispatch) => {
//     try {
//       dispatch({ type: ORDER_DOWNLOAD_REQUEST });

//       let formData;

//       if (customFormData) {
//         // Use the provided FormData (for sticker with image)
//         formData = customFormData;
//       } else {
//         // Create new FormData for other formats
//         formData = new FormData();
//         formData.append("file_type", format);
//       }

//       // Call the API with the format parameter
//       const response = await axiosInstance.post(
//         `/api/generate-qr-codes-file/${orderId}/`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       const { file_url, filename } = response.data;

//       if (!file_url) {
//         throw new Error("No download URL found in response");
//       }

//       // Fetch the file as a blob to ensure proper download
//       try {
//         const fileResponse = await fetch(file_url, {
//           method: 'GET',
//           mode: 'cors',
//         });

//         if (!fileResponse.ok) {
//           throw new Error(`Failed to fetch file: ${fileResponse.statusText}`);
//         }

//         const blob = await fileResponse.blob();
        
//         // Create download link with blob URL
//         const blobUrl = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = blobUrl;
//         link.setAttribute("download", filename || `Order_${orderId}_${format}.zip`);
//         document.body.appendChild(link);
//         link.click();
        
//         // Clean up
//         setTimeout(() => {
//           document.body.removeChild(link);
//           window.URL.revokeObjectURL(blobUrl);
//         }, 100);

//         dispatch({ type: ORDER_DOWNLOAD_SUCCESS });
//         return { success: true, filename: filename || `Order_${orderId}_${format}.zip` };
//       } catch (fetchError) {
//         console.error("Error downloading file:", fetchError);
//         // Fallback: try direct link approach
//         const link = document.createElement("a");
//         link.href = file_url;
//         link.setAttribute("download", filename || `Order_${orderId}_${format}.zip`);
//         link.setAttribute("target", "_blank");
//         document.body.appendChild(link);
//         link.click();
//         setTimeout(() => {
//           document.body.removeChild(link);
//         }, 100);

//         dispatch({ type: ORDER_DOWNLOAD_SUCCESS });
//         return { success: true, filename: filename || `Order_${orderId}_${format}.zip` };
//       }
//     } catch (error) {
//       console.error("Download error:", error);
//       const errorMessage = error.response?.data?.message || error.message || "Failed to download file";
//       dispatch({
//         type: ORDER_DOWNLOAD_FAIL,
//         payload: errorMessage,
//       });
//       throw new Error(errorMessage);
//     }
//   };

export const downloadOrderZIP =
  (orderId, token, format, customFormData = null) =>
  async (dispatch) => {
    try {
      dispatch({ type: ORDER_DOWNLOAD_REQUEST });

      let formData;
      if (customFormData) {
        formData = customFormData;
      } else {
        formData = new FormData();
        formData.append("file_type", format);
      }

      const response = await axiosInstance.post(
        `/api/generate-qr-codes-file/${orderId}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // ── Handle async 202 response (sticker / background job) ──
      if (response.status === 202 || response.data?.status === 202) {
        dispatch({ type: ORDER_DOWNLOAD_SUCCESS });
        return {
          success: true,
          async: true,
          message: response.data?.message || "File generation started. Check back shortly.",
          filename: null,
        };
      }

      const { file_url, filename } = response.data;

      if (!file_url) {
        throw new Error("No download URL found in response");
      }

      // ── Synchronous download ──
      try {
        const fileResponse = await fetch(file_url, { method: "GET", mode: "cors" });
        if (!fileResponse.ok) throw new Error(`Failed to fetch file: ${fileResponse.statusText}`);

        const blob = await fileResponse.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", filename || `Order_${orderId}_${format}.zip`);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        }, 100);
      } catch (fetchError) {
        // Fallback direct link
        const link = document.createElement("a");
        link.href = file_url;
        link.setAttribute("download", filename || `Order_${orderId}_${format}.zip`);
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        setTimeout(() => document.body.removeChild(link), 100);
      }

      dispatch({ type: ORDER_DOWNLOAD_SUCCESS });
      return { success: true, async: false, filename: filename || `Order_${orderId}_${format}.zip` };

    } catch (error) {
      console.error("Download error:", error);
      const errorMessage = error.response?.data?.message || error.message || "Failed to download file";
      dispatch({ type: ORDER_DOWNLOAD_FAIL, payload: errorMessage });
      throw new Error(errorMessage);
    }
  };

 export const downloadOrderFile = (orderId, token) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`/api/download-order/${orderId}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const fileUrl = response.data?.order_download_url;  // ← fix key name

    if (fileUrl) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("target", "_blank");
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      setTimeout(() => document.body.removeChild(link), 100);
    }

    return { success: true, data: response.data };
  } catch (error) {
    console.error("Download order file error:", error);
    return { success: false, error: error.message };
  }
};
export const updateOrderDownloadStatus = (orderId, isDownloaded, token) => {
  return async (dispatch) => {
    try {
      dispatch({ type: UPDATE_ORDER_DOWNLOAD_STATUS_REQUEST });

      const response = await axiosInstance.post(
        "/api/update-order-download-status/",
        {
          order_id: orderId,
          is_downloaded: isDownloaded,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === 200) {
        dispatch({
          type: UPDATE_ORDER_DOWNLOAD_STATUS_SUCCESS,
          payload: response.data.data,
        });
        return {
          success: true,
          data: response.data.data,
        };
      } else {
        throw new Error(response.data.message || "Failed to update download status");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to update download status";
      dispatch({
        type: UPDATE_ORDER_DOWNLOAD_STATUS_FAIL,
        payload: errorMessage,
      });
      throw new Error(errorMessage);
    }
  };
};

// export const getOrderDetailsWithGifts = (orderId, token, download = false) => {
//   return async (dispatch) => {
//     try {
//       const response = await axiosInstance.get("/api/get-order-with-gift-allotments/", {
//         // params: { order_id: orderId },
//          params: { order_id: orderId, ...(download && { download: true }) },
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (response.status === 200 && response.data.data) {
//         return { success: true, data: response.data.data };
//       } else {
//         throw new Error("Unexpected response format");
//       }
//     } catch (error) {
//       console.error("Error fetching order details:", error);
//       const errorMsg =
//         error.response?.data?.message ||
//         error.response?.data?.detail ||
//         error.message ||
//         "Failed to fetch order details";
//       return { success: false, error: errorMsg };
//     }
//   };
// };

export const getOrderDetailsWithGifts = (orderId, token, download = false) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get("/api/get-order-with-gift-allotments/", {
        params: download ? { download: true } : { order_id: orderId },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200 && response.data.data) {
        return { success: true, data: response.data.data, download_url: response.data.download_url || null, };
      } else {
        throw new Error("Unexpected response format");
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      const errorMsg =
        error.response?.data?.message ||
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch order details";
      return { success: false, error: errorMsg };
    }
  };
};
export const fetchPaymentList = (token) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_LIST_REQUEST });

    console.log("Dispatching payment list fetch with token:", token);

    const response = await axiosInstance.get("/api/payment-list/", {
      headers: {
        Authorization: `Bearer ${token}`, // Or `Token` if your backend wants that
      },
    });

    console.log("Payment list response:", response.data);

    dispatch({
      type: PAYMENT_LIST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error(
      "Payment list fetch failed:",
      error.response?.data || error.message
    );
    dispatch({
      type: PAYMENT_LIST_FAIL,
      payload:
        error.response?.data?.detail || error.message || "Something went wrong",
    });
  }
};

export const submitPayment =
  (payment_id, paymentData, token) => async (dispatch) => {
    try {
      console.log("Submitting payment with payment_id:", payment_id);
      console.log("Payment data being sent:", paymentData);

      dispatch({ type: PAYMENT_REQUEST });

      const response = await axiosInstance.post(
        `/api/update-payment/${payment_id}/`,
        paymentData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({ type: PAYMENT_SUCCESS, payload: response.data });

      toast.success(response.data.message || "Payment submitted successfully.");
    } catch (error) {
      dispatch({
        type: PAYMENT_FAIL,
        payload: error.response?.data || error.message,
      });
      toast.error(
        error.response?.data?.detail ||
          error.message ||
          "Failed to submit payment"
      );
    }
  };
export const fetchStateCityStats = (token) => async (dispatch) => {
  try {
    dispatch({ type: STATE_CITY_REQUEST });
    const response = await axiosInstance.get("/api/city-state-wise-count/", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("State City response:", response.data); // Check if the data is correct
    dispatch({ type: STATE_CITY_SUCCESS, payload: response.data });
    console.log("State City data fetched successfully:........", response.data);
  } catch (error) {
    dispatch({
      type: STATE_CITY_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    console.log(
      "State City data fetch error:",
      error.response?.data || error.message
    );
  }
};
export const getQrStatusByDate = (date, token) => async (dispatch) => {
  try {
    dispatch({ type: QRSTATUS_DATE_REQUEST });

    const response = await axiosInstance.get(
      `/api/qr-redemption-stats/?date=${date}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({ type: QRSTATUS_DATE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: QRSTATUS_DATE_FAILURE,
      payload:
        error.response?.data?.detail || error.message || "Something went wrong",
    });
  }
};
// export const dealerAccess = (token, userId) => async (dispatch) => {
//   try {
//     dispatch({ type: GET_DEALER_ACCESS_REQUEST });  
//     const response = await axiosInstance.get("/api/module-permissions/", {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       params: userId ? { user_id: userId } : {}, // ← pass user_id as query param
//     });
//      console.log("dealerAccess response:", response.data);
//     dispatch({ type: GET_DEALER_ACCESS_SUCCESS, payload: response.data });
//   } catch (error) {
//     dispatch({
//       type: GET_DEALER_ACCESS_FAIL,
//       payload: error.response ? error.response.data : error.message,
//     });
//   }
// };

export const dealerAccess = (token, userId) => async (dispatch) => {
  console.log("dealerAccess called with token:", token); // ← add this
  try {
    dispatch({ type: GET_DEALER_ACCESS_REQUEST });  
    const response = await axiosInstance.get("/api/module-permissions/", {
      headers: { Authorization: `Bearer ${token}` },
      params: userId ? { user_id: userId } : {},
    });
    console.log("dealerAccess response:", response.data);
    dispatch({ type: GET_DEALER_ACCESS_SUCCESS, payload: response.data });
   
    return response.data; 
  } catch (error) {
    console.log("dealerAccess ERROR:", error.response?.data || error.message); // ← add this
    dispatch({
      type: GET_DEALER_ACCESS_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
  }
};
export const updateDealerAccess = (token, dealerUserId, permissions) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_DEALER_ACCESS_REQUEST });
    const response = await axiosInstance.post(
      `/api/set-module-permission/${dealerUserId}/`,
      permissions,                                    // array sent directly as request body
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({ type: UPDATE_DEALER_ACCESS_SUCCESS, payload: response.data });
    // dispatch({ type: GET_DEALER_ACCESS_SUCCESS, payload: response.data });
     const successMessage =
      response.data.message ||
      "Order updated successfully. Please check your email for the QR code.";
    toast.success(successMessage);
    return response.data;
  } catch (error) {
    dispatch({
      type: UPDATE_DEALER_ACCESS_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to create order";

    toast.error(errorMessage);
  }
};
export const createSlogan = (sloganData, token) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_SLOGAN_REQUEST });
    try {
      const response = await axiosInstance.post(
        "/api/add-slogan/",
        sloganData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: CREATE_SLOGAN_SUCCESS,
        payload: response.data,
      });
      return { type: CREATE_SLOGAN_SUCCESS, payload: response.data };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: CREATE_SLOGAN_FAIL,
        payload: errorPayload,
      });
      return { type: CREATE_SLOGAN_FAIL, payload: errorPayload };
    }
  };
};
export const fetchSlogan = (token, options = {}) => {  
  return async (dispatch) => {
    dispatch({ type: GET_SLOGAN_REQUEST });
    try {
     

      const response = await axiosInstance.get("/api/slogans/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({
        type: GET_SLOGAN_SUCCESS,
        payload: response.data.data,
      });

      return {
        type: GET_SLOGAN_SUCCESS,
        payload: response.data,
      };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: GET_SLOGAN_FAIL,
        payload: errorPayload,
      });
      return {
        type: GET_SLOGAN_FAIL,
        payload: errorPayload,
      };
    }
  };
};

export const getSalesmanRedemptionStats = (reedemedsalesqrcountData, token) => {
  return async (dispatch) => {
    dispatch({ type: SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_REQUEST });
    try {
      const response = await axiosInstance.post(
        "/api/salesman-qr-redemption-status/",
        reedemedsalesqrcountData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_SUCCESS,
        payload: response.data,
      });
    return { type: SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_SUCCESS, payload: response.data }; 
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_FAIL,
        payload: errorPayload,
      });
      return { type: SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_FAIL, payload: errorPayload };
    }
  };
};

export const getOrderQrStatusExcel = (orderId, token) => async (dispatch) => {
  dispatch({ type: "ORDER_QR_STATUS_REQUEST" });
  try {
    const { data } = await axiosInstance.post(
      "/api/order-qr-status-excel/",
      { order_id: orderId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ORDER_QR_STATUS_SUCCESS", payload: data });
    return {
      success: true,
      download_url: data.download_url,
      message: data.message,
      summary: data.summary,
    };
  } catch (error) {
    const errMsg =
      error?.response?.data?.message ||
      error.message ||
      "Failed to generate QR status report";
    dispatch({ type: "ORDER_QR_STATUS_FAIL", payload: errMsg });
    return { success: false, error: errMsg };
  }
};

export const getCustomerWiseRedemptionSummary =
  (params = {}, token) =>
  async (dispatch) => {
    // ?customer_id=101 → detail call: return the data, don't touch the list in Redux
  const isDetail = Boolean(params.customer_id) || Boolean(params.is_download);

    if (!isDetail) dispatch({ type: CUSTOMER_REDEMPTION_SUMMARY_REQUEST });
    try {
      const response = await axiosInstance.get(
        "/api/customer-wise-redemption-summary/",
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        }
      );
      if (!isDetail) {
        dispatch({
          type: CUSTOMER_REDEMPTION_SUMMARY_SUCCESS,
          payload: response.data,
        });
      }
      return {
        success: true,
        data: response.data,
        customer: response.data?.data?.[0] || null,
      };
    } catch (error) {
      const errMsg =
        error.response?.data?.message ||
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch redemption summary";
      if (!isDetail) dispatch({ type: CUSTOMER_REDEMPTION_SUMMARY_FAIL, payload: errMsg });
      return { success: false, error: errMsg };
    }
  };